<div class="model-detail">
  <app-header [forceLightBackground]="true"></app-header>
  
  <div class="model-detail--content">
    <app-asset-header
      [config]="headerConfig"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      [isLiked]="isLiked"
      [showActions]="true"
      (bookmarkClick)="onBookmarkClick()"
      (likeClick)="onLikeClick()"
    ></app-asset-header>
    
    <!-- Main Content: Two Column Layout -->
    <div class="model-detail--main-section" *ngIf="!isLoading">
      <div class="model-detail--container">
        <!-- Warning Message for Pending Publish Status -->
        <div class="model-detail--pending-warning" *ngIf="isPublishStatusPending">
          <div class="model-detail--pending-warning-content">
            <svg class="model-detail--pending-warning-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="model-detail--pending-warning-text">
              <strong>Your model is under review.</strong> Will be available for other users to view the model post Approval from the organisation administrator.
            </div>
          </div>
        </div>

        <!-- Info Message for Declined/Rejected Publish Status -->
        <div class="model-detail--declined-info" *ngIf="isPublishStatusDeclined">
          <div class="model-detail--declined-info-content">
            <svg class="model-detail--declined-info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="model-detail--declined-info-text">
              Your request to approve the Model is being Rejected. Please try creating a new one and get the approval from the Org Admin.
            </div>
          </div>
        </div>

        <!-- Tabs Navigation -->
        <div class="model-detail--tabs-wrapper">
          <div class="model-detail--tabs">
            <button class="model-detail--tab" [class.active]="activeTab === 'model'" (click)="setActiveTab('model')" type="button">Model</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'details'" (click)="setActiveTab('details')" type="button">Details</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'visualisation'" (click)="setActiveTab('visualisation')" type="button">Visualisation</button>
            <button class="model-detail--tab" *ngIf="!hasMediaUrl" [class.active]="activeTab === 'sql-playground'" (click)="setActiveTab('sql-playground')" type="button">SQL Playground</button>
            <button class="model-detail--tab" [class.active]="activeTab === 'discussion'" (click)="setActiveTab('discussion')" type="button">Discussion</button>
          </div>
          <div class="model-detail--tabs-actions" *ngIf="activeTab === 'discussion'">
            <button class="model-detail--new-discussion-btn" type="button" (click)="createNewDiscussion()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              New Discussion
            </button>
          </div>
        </div>

        <div class="model-detail--row" [class.full-width]="activeTab !== 'model'">
          <!-- Left Column: Tags, Description and Attributes (col-8) -->
          <div class="model-detail--col-8" [class.full-width]="activeTab !== 'model'">
            <!-- Tab Content: Model -->
            <div class="model-detail--tab-content" *ngIf="activeTab === 'model'">
            <!-- Tags -->
            <div class="model-detail--tags-header" *ngIf="modelTags.length > 0">
              <span 
                *ngFor="let tag of visibleTags" 
                class="model-detail--tag-header"
                [title]="tag"
              >
                {{ tag }}
              </span>
              <span 
                *ngIf="remainingTagsCount > 0"
                class="model-detail--more-link-header"
                (click)="openTagsModal()"
              >
                +{{ remainingTagsCount }} More
              </span>
            </div>
            
            <!-- Description -->
            <p class="model-detail--description" *ngIf="modelDescription">{{ modelDescription }}</p>
            
            <!-- Model Attributes -->
            <div class="model-detail--attributes-section" *ngIf="hasModelDetails">
              <div class="model-detail--attribute-item" *ngIf="modelDetails.uploadedBy">
                <img src="/assets/user-circle-2.svg" alt="User" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Uploaded by:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.uploadedBy }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.organisationType">
                <img src="/assets/people (2).svg" alt="People" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Organisation type:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.organisationType }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.industry">
                <img src="/assets/building-2 (1).svg" alt="Building" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">Industry:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.industry }}</div>
                </div>
              </div>
              
              <div class="model-detail--attribute-item" *ngIf="modelDetails.license">
                <img src="/assets/gavel.svg" alt="License" class="model-detail--attribute-icon" width="20" height="20" />
                <div class="model-detail--attribute-content">
                  <div class="model-detail--attribute-label">License:</div>
                  <div class="model-detail--attribute-value">{{ modelDetails.license }}</div>
                </div>
              </div>
            </div>
            </div>

            <!-- Tab Content: Details, Visualisation, SQL Playground, Discussion - blank placeholder -->
            <!-- Tab Content: Discussion (choice/all API) -->
            <div class="model-detail--tab-content dataset-detail--discussion-loading" *ngIf="activeTab === 'discussion' && modelDiscussionsLoading">
              <p>Loading discussions...</p>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-error" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && modelDiscussionsError">
              <p>{{ modelDiscussionsError }}</p>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-list" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && !modelDiscussionsError && modelDiscussions.length > 0">
              <app-asset-discussion-list
                [discussions]="modelDiscussions"
                assetTypeLabel="Model"
                (navigate)="navigateToDiscussion($event)"
              ></app-asset-discussion-list>
            </div>
            <div class="model-detail--tab-content dataset-detail--discussion-empty" *ngIf="activeTab === 'discussion' && !modelDiscussionsLoading && !modelDiscussionsError && modelDiscussions.length === 0">
              <p>No discussions yet. Be the first to start a discussion about this model.</p>
            </div>

            <div class="model-detail--tab-placeholder" *ngIf="activeTab === 'details' || activeTab === 'visualisation' || activeTab === 'sql-playground'">
              <p>Content coming soon.</p>
            </div>
          </div>

          <!-- Right Column: Model Details and Actions (col-3) -->
          <div class="model-detail--col-3" *ngIf="activeTab === 'model'">
            <!-- Activity Overview Card -->
            <div class="model-detail--activity-overview">
              <div class="activity-overview--header">
                <h3 class="model-detail--section-title">Activity Overview</h3>
              </div>
              <div class="activity-overview--metrics">
                <!-- Like -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.likes | number }}</span>
                </div>
                <!-- View -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.views | number }}</span>
                </div>
              </div>
            </div>

            <div class="model-detail--right-section">
              <div class="model-detail--right-header">
                <h3 class="model-detail--section-title">Model details</h3>
                <button 
                  class="model-detail--header-btn"
                  (click)="onGithubRepoClick()" 
                  *ngIf="hasMediaUrl"
                >
                  <ng-container *ngIf="isMediaUrlGithub">
                    <img src="/assets/github.svg" alt="GitHub" class="model-detail--header-btn-icon" width="14" height="14" />
                    <span>GitHub Repo</span>
                  </ng-container>
                  <ng-container *ngIf="!isMediaUrlGithub">
                    <svg class="model-detail--header-btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <polyline points="15 3 21 3 21 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Redirect Link</span>
                  </ng-container>
                </button>
              </div>
              
              <!-- Model Details List -->
              <div class="model-detail--details-list">
                <!-- Permission - aligned with dataset design -->
                <div class="model-detail--detail-item model-detail--permission-item" *ngIf="modelCardDetails.badge">
                  <svg class="model-detail--detail-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Permission:</div>
                    <div class="model-detail--detail-value">
                      <span class="model-detail--permission-badge">
                        <svg class="model-detail--permission-badge-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="12" cy="12" r="2" fill="currentColor"/>
                        </svg>
                        <span>{{ modelCardDetails.badge }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelDetails.uploadedBy">
                  <img src="/assets/user-circle-2.svg" alt="Uploaded by" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Uploaded by:</div>
                    <div class="model-detail--detail-value">{{ modelDetails.uploadedBy }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.modelType">
                  <img src="/assets/cpu.svg" alt="Model Type" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Model Type:</div>
                    <div class="model-detail--detail-value">{{ modelCardDetails.modelType }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.programmingLanguage">
                  <img src="/assets/code-2.svg" alt="Programming Language" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Programming Language:</div>
                    <div class="model-detail--detail-value">{{ modelCardDetails.programmingLanguage }}</div>
                  </div>
                </div>
                
                <div class="model-detail--detail-item" *ngIf="modelCardDetails.createdAt">
                  <img src="/assets/history.svg" alt="Last Updated" class="model-detail--detail-icon" width="20" height="20" />
                  <div class="model-detail--detail-content">
                    <div class="model-detail--detail-label">Last Updated:</div>
                    <div class="model-detail--detail-value">
                      {{ getCreatedAtDate(modelCardDetails.createdAt) }}
                      <span class="model-detail--detail-time" *ngIf="getCreatedAtTime(modelCardDetails.createdAt)">
                        {{ getCreatedAtTime(modelCardDetails.createdAt) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="model-detail--loading" *ngIf="isLoading">
      <div class="model-detail--container">
        <p>Loading model details...</p>
      </div>
    </div>

    <!-- Similar Models Section -->
    <div class="model-detail--similar-section" *ngIf="!isLoading">
      <div class="model-detail--container">
        <app-similar-datasets 
          [datasets]="similarModels"
          [title]="'Related Models'"
          [assetType]="'model'"
          [itemsToShow]="3"
          [showDots]="true"
          [showArrows]="true"
          [gap]="24"
        ></app-similar-datasets>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Tags Modal -->
  <app-modal
    [(visible)]="showTagsModal"
    header="All Tags"
    [width]="'600px'"
    [showFooter]="false"
    (visibleChange)="showTagsModal = $event"
  >
    <div class="tags-modal-content">
      <div class="tags-modal--tags">
        <span
          *ngFor="let tag of allTags"
          class="model-detail--tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </app-modal>

  <!-- Login Modal -->
  <app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>
</div>
